import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-net',
  templateUrl: './net.component.html',
  styleUrls: ['./net.component.scss', './net.component.media.scss']
})
export class NetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  showArr = [
    {
      src: './assets/show-5.jpg',
      label: '2019 Shanghai International Die Casting Exhibition'
    },
    {
      src: './assets/show-3.jpg',
      label: '2018 International Die Casting Exhibition, Yokohama, Japan'
    },
    {
      src: './assets/show-4.jpg',
      label: '2018 Shanghai International Die Casting Exhibition'
    },
    {
      src: './assets/show-2.jpg',
      label: '2017 Shanghai International Die Casting Exhibition'
    },
    {
      src: './assets/show-6.jpg',
      label: '2016 Shanghai International Die Casting Exhibition'
    },
    {
      src: './assets/show-1.jpg',
      label: '2015 Indianapolis Die Casting Show, USA'
    }
  ];
}
